// removed by extract-text-webpack-plugin
module.exports = {"base":"ModernizationOverlay_base--shK16","base__opened":"ModernizationOverlay_base__opened--jIhKD","baseOpened":"ModernizationOverlay_base__opened--jIhKD","content":"ModernizationOverlay_content--3u3bw","back":"ModernizationOverlay_back--q0e8Z"};


//////////////////
// WEBPACK FOOTER
// ./components/ModernizationOverlay/ModernizationOverlay.scss
// module id = 2086
// module chunks = 11